<template>

    <div class="layout__container">

        <div class="layout__margin-25-0">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Sales Insight</el-breadcrumb-item>
                <el-breadcrumb-item><span class="text__colour-teal">Total Sales</span></el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <h3 class="text__align-center text__colour-teal">Total Sales</h3>

        <div class="layout__position-center">
            <div class="layout__position-left layout__width-100">
                <TotalSalesSearch v-bind:searchParams="searchParams" v-bind:sales="sales"></TotalSalesSearch>
            </div>

            <div class="insights-table layout__width-100 layout__position-left">
                <div class="el-table__scroll-wrapper">
                    <div class="el-table__scroll-div">
                    </div>
                </div>
                <el-table class="el-table__09vh layout__height-1240px layout__scrolling__right" :data="sales.slice(this.start-1, this.end)" style="width: 100%;" @sort-change="handleSortOrderChange" 
                v-loading.fullscreen.lock="loading" element-loading-text="Loading..." element-loading-background="rgba(79, 147, 168, 0.2)" empty-text="No data has been returned for the selected dates">
                    <el-table-column prop="day" label="Day" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="50px">
                    </el-table-column>
                    <el-table-column prop="month" label="Month" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" width="100px" :formatter="getMonthName">
                    </el-table-column>
                    <el-table-column prop="year" label="Year" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="50px">
                    </el-table-column>
                    <el-table-column prop="territory" label="Territory" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" width="130px">
                    </el-table-column>
                    <el-table-column prop="toolkit" label="Toolkit" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" :formatter="getCurrencyAmount">
                    </el-table-column>
                    <el-table-column prop="email" label="Email" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" :formatter="getCurrencyAmount">
                    </el-table-column>
                    <el-table-column prop="bespoke" label="Bespoke" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" :formatter="getCurrencyAmount">
                    </el-table-column>
                    <el-table-column prop="instantprint" label="InstantPrint" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" :formatter="getCurrencyAmount">
                    </el-table-column>
                    <el-table-column prop="photofixr" label="PhotoFixr" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" :formatter="getCurrencyAmount">
                    </el-table-column>
                    <el-table-column prop="myravensworth" label="MyRavensworth" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" :formatter="getCurrencyAmount">
                    </el-table-column>
                    <el-table-column prop="delivery" label="Delivery" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" :formatter="getCurrencyAmount">
                    </el-table-column>
                    <el-table-column prop="total" label="Total" class-name="layout__width-10 text__style-bold el-table-column__no-pointer" sortable="custom" :formatter="getCurrencyAmount" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="budget" label="Budget" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" :formatter="getCurrencyAmount" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="variance" label="Variance" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" :formatter="formatPercentage">
                    </el-table-column>
                    <el-table-column class-name="layout__width-10 el-table-column__no-pointer" width="100px">
                        <template slot-scope="scope">
                            <el-button class="button-teal button__download" size="mini" :loading="loadings[scope.$index]" v-on:click="csv(scope.$index, scope.row)">Download
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table class="el-table__09vh" :data="totals" height="50px" :show-header="false" style="width: calc(100% - 15px);"
                v-loading.fullscreen.lock="loading" element-loading-text="Loading..." element-loading-background="rgba(79, 147, 168, 0.2)" empty-text="No data has been returned for the selected dates">
                    <el-table-column class-name="layout__width-5 el-table-column__no-pointer el-table__summary-row" width="50px">
                    </el-table-column>
                    <el-table-column class-name="layout__width-10 el-table-column__no-pointer el-table__summary-row" width="100px">
                    </el-table-column>
                    <el-table-column class-name="layout__width-5 el-table-column__no-pointer el-table__summary-row" width="50px">
                    </el-table-column>
                    <el-table-column class-name="layout__width-10 el-table-column__no-pointer el-table__summary-row" width="130px">
                    </el-table-column>
                    <el-table-column prop="toolkit" class-name="layout__width-10 el-table-column__no-pointer el-table__summary-row" :formatter="getCurrencyAmount" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="email" class-name="layout__width-10 el-table-column__no-pointer el-table__summary-row" :formatter="getCurrencyAmount" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="bespoke" class-name="layout__width-10 el-table-column__no-pointer el-table__summary-row" :formatter="getCurrencyAmount" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="instantprint" class-name="layout__width-10 el-table-column__no-pointer el-table__summary-row" :formatter="getCurrencyAmount" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="photofixr" class-name="layout__width-10 el-table-column__no-pointer el-table__summary-row" :formatter="getCurrencyAmount" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="myravensworth" class-name="layout__width-10 el-table-column__no-pointer el-table__summary-row" :formatter="getCurrencyAmount" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="delivery" class-name="layout__width-10 el-table-column__no-pointer el-table__summary-row" :formatter="getCurrencyAmount" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="total" class-name="layout__width-10 text__style-bold el-table-column__no-pointer el-table__summary-row" :formatter="getCurrencyAmount" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="budget" class-name="layout__width-10 el-table-column__no-pointer el-table__summary-row" :formatter="getCurrencyAmount" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column class-name="layout__width-10 el-table-column__no-pointer el-table__summary-row">
                    </el-table-column>
                    <el-table-column class-name="layout__width-10 el-table-column__no-pointer el-table__summary-row" width="100px">
                    </el-table-column>
                </el-table>
            </div>
            <div class="">
                <div class="layout__padding-clear layout__padding-8-0 layout__border__all-1px">
                    <div class="text__align-center layout__padding-8-0">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :page-sizes="[20, 40, 60, 80, 100, 200]"
                            :page-size="200"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="this.sales.length">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <canvas id="total-sales-chart" class="component__chart-main component__chart-float-center component__chart-padding-30px"></canvas>
    </div>

</template>

<script>

    import Chart from 'chart.js';
    import moment from 'moment';
    import Axios from 'axios';
    import TotalSalesSearch from '@/components/insights/TotalSalesSearch';
    import barChartBase from '../../mixins/bar-chart-base.js';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {sortJsonArrayHelper} from '@/mixins/sort-json-array.js';
 
    export default {
        name: "sales",
        mixins: [axios, csvDownloadHelper, dataFormatter, sortJsonArrayHelper],
        components: {
            TotalSalesSearch
        },
        props: {
            view: ''
        },
        data() {
            return {
                selectedDay: '',
                selectedMonth: '',
                selectedYear: '',
                selectedTerritory: '',
                sales: [],
                totals: [],
                start: 1,
                end: 200,
                pagination: 200,
                loading: false,
                loadings: {},
                serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
                searchParams: {
                    salesDateRange: [new Date().toLocaleDateString('en-GB'), new Date().toLocaleDateString('en-GB')],
                    salesFreeText: ''
                },
            }
        },
        created() {
            this.isUserAuthorised();
            this.initLoaders();
        },
        mounted() {
            var bw = document.getElementsByClassName("el-table__body-wrapper");
            bw[0].addEventListener('scroll', this.handleScroll1);
            var sw = document.getElementsByClassName("el-table__scroll-wrapper");
            sw[0].addEventListener('scroll', this.handleScroll2);
        },
        updated() {
            var h = document.getElementsByClassName("el-table__header");
            var sd = document.getElementsByClassName("el-table__scroll-div");
            sd[0].style.width = h[0].style.width;

            var bw = document.getElementsByClassName("el-table__body-wrapper");
            if (bw[0].scrollWidth > bw[0].clientWidth) {
                sd[0].style.display = "block";
            } else {
                sd[0].style.display = "none";
            }
        },
        methods: {
            initLoaders: function () {
                let self = this;
                this.sales.forEach(function (v, i) {
	                this.$set(self.loadings, i, false);
                });
            },
            handleScroll1(e) {
                var bw = document.getElementsByClassName("el-table__body-wrapper");
                bw[1].scrollLeft = bw[0].scrollLeft;
                var sw = document.getElementsByClassName("el-table__scroll-wrapper");
                sw[0].scrollLeft = bw[0].scrollLeft;
            },
            handleScroll2(e) {
                var sw = document.getElementsByClassName("el-table__scroll-wrapper");
                var bw = document.getElementsByClassName("el-table__body-wrapper");
                bw[0].scrollLeft = sw[0].scrollLeft;
            },
            getMonthName(row, column) {
                let monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];
                return monthNames[row.month - 1];
            },
            getCurrencyAmount(row, column, cellValue) {
                if (typeof cellValue === 'undefined') {
                    return '£0'
                } else {
                    return '£' + cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            },
            handleSizeChange(val) {
                console.log(`${val} items per page`);

                this.pagination = val
                console.log(this.start)
                this.end = this.pagination;
                console.log(this.end)
            },
            handleCurrentChange(val) {
                console.log(`current page: ${val}`);

                this.start = (val - 1) * this.pagination + 1;
                console.log(this.start)
                this.end = val * this.pagination;
                console.log(this.end)
            },
            handleSortOrderChange(sortProps) {
                console.log('prop: ' + sortProps.prop);
                console.log('order: ' + sortProps.order);

                this.sortJsonArray(this.sales, sortProps.prop, sortProps.order.slice(0, 3));
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                var summary_total = 0, summary_budget = 0;

                columns.forEach((column, index) => {
                    var noTotalCols = ['Day', 'Month', 'Year'];

                    if (noTotalCols.indexOf(column.label) >= 0) {
                        sums[index] = '';
                        return;
                    }

                    const values = data.map(item => Number(item[column.property]));

                    if (column.label == 'Total') {
                        if (!values.every(value => isNaN(value))) {
                            summary_total =  values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0);
                        } else {
                            summary_total = 0;
                        }
                    }

                    if (column.label == 'Budget') {
                        if (!values.every(value => isNaN(value))) {
                            summary_budget =  values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0);
                        } else {
                            summary_budget = 0;
                        }
                    }

                    if (column.label == 'Variance') {
                        const value = 0 - (100 - ((summary_total / summary_budget) * 100));
                        sums[index] = Math.round(value).toString() + '%';
                    } else {
                        const values = data.map(item => Number(item[column.property]));
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = '£' + this.returnWithCommas(values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0).toFixed(0).toString());
                        } else {
                            sums[index] = '';
                        }
                    }
                });

                return sums;
            },
            csv(index, row) {
                this.selectedDay = row.day;
                this.selectedMonth = row.month;
                this.selectedYear = row.year;
                this.selectedTerritory = row.territory;

                console.log('this.selectedDay:' + this.selectedDay);
                console.log('this.selectedMonth:' + this.selectedMonth);
                console.log('this.selectedYear:' + this.selectedYear);
                console.log('this.selectedTerritory:' + this.selectedTerritory);

                console.log('before')
                console.log(this.searchParams)

                let searchTerms = Object.assign({}, this.searchParams)
                console.log('searchTerms')
                console.log(searchTerms)

                console.log('after search is copied')
                console.log(this.searchParams)

                console.log('after search is copied - new object')
                console.log(searchTerms)

                var territory = this.selectedTerritory.replace(' ', '%20'),
                    endpoint = this.serviceRouteUrl + '/api/v1/insights/order/TotalSalesDetails?day=' + this.selectedDay + '&month=' + this.selectedMonth + '&year=' + this.selectedYear + '&territory=' + territory;

                console.log(endpoint)

                this.$set(this.loadings, index, true);

                Axios.get(endpoint, this.returnHeaderUsingToken())
                .then(response => {
                    const fields = [
                        {label: 'Order Id', value: 'order_Id'},
                        {label: 'Ordered', value: (row, field) => row.ordered.replace('T', ' ').replace(/\.[0-9]{3}/, '').replace(/\.[0-9]{2}/, '').replace(/\.[0-9]{1}/, '')},
                        {label: 'Ordered Month', value: (row, field) => this.returnMonthFromDate(row.ordered)},
                        {label: 'Source Id', value: 'source_Id'},
                        {label: 'Job Id', value: 'job_Id'},
                        {label: 'Category', value: 'category'},
                        {label: 'Brand', value: 'brand'},
                        {label: 'Price Code', value: 'price_Code'},
                        {label: 'Product', value: 'product'},
                        {label: 'Stock', value: 'stock'},
                        {label: 'Finishing', value: 'finishing'},
                        {label: 'Product Category', value: 'product_Category'},
                        {label: 'Product Description', value: 'product_Description'},
                        {label: 'Territory', value: 'territory'},
                        {label: 'Status', value: 'status'},
                        {label: 'Branch', value: 'branch'},
                        {label: 'Name', value: 'name'},
                        {label: 'Job Name', value: 'job_Name'},
                        {label: 'Quantity', value: 'quantity'},
                        {label: 'Value', value: 'value'},
                        {label: 'Billing Status', value: 'billing_Status'},
                        {label: 'Cost Price', value: 'cost_Price'},
                        {label: 'Margin (%)', value: (row, field) => row.marginpercent + '%'}
                    ];

                    var orders = response.data.totalSalesDetails;
                    for (var order, i = 0; order = orders[i++];) {
                        if (order.job_Name.match(/Direct Mail.*/)) {
                            order.marginpercent = 1.9;
                            /*order.marginpounds = (order.listprice * 0.019).toFixed(0).toString();
                            order.cost_Price = order.listprice - order.marginpounds;*/
                        }

                        if (order.job_Name == 'Delivery Charge') {
                            order.marginpercent = 23;
                            /*order.marginpounds = (order.listprice * 0.23).toFixed(0).toString();
                            order.cost_Price = order.listprice - order.marginpounds;*/
                        }
                    }

                    this.downloadCsv(this.exportDate, fields, orders)

                    this.$nextTick(() => { // Loading should be closed asynchronously
                        this.$set(this.loadings, index, false);
                    });
                })
                .catch(error => {
                    if (error.response) {
                        this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                    }

                    this.$nextTick(() => { // Loading should be closed asynchronously
                        this.$set(this.loadings, index, false);
                    });
                })
            }
        }
    };
</script>